// extracted by mini-css-extract-plugin
export var animated = "brand-logo-module--animated--ff97e";
export var animationPaused = "brand-logo-module--animationPaused--03745";
export var baseTextAltGlobal = "brand-logo-module--base-text-alt--global--68512";
export var baseTextGlobal = "brand-logo-module--base-text--global--0f360";
export var blockSpacing100 = "brand-logo-module--block-spacing-100--54d18";
export var blockSpacing50 = "brand-logo-module--block-spacing-50--fcef3";
export var blockVPadding100 = "brand-logo-module--block-v-padding-100--3e8cc";
export var blockVPadding50 = "brand-logo-module--block-v-padding-50--2f84e";
export var captionTextGlobal = "brand-logo-module--caption-text--global--daf06";
export var cmsRenderedContentGlobal = "brand-logo-module--cms-rendered-content--global--312d0";
export var container = "brand-logo-module--container--a07a8";
export var contract = "brand-logo-module--contract--e9bc9";
export var contracted = "brand-logo-module--contracted--0d36c";
export var dark = "brand-logo-module--dark--150b2";
export var defaultHSpacingGlobal = "brand-logo-module--default-h-spacing--global--b2323";
export var expand = "brand-logo-module--expand--fef12";
export var expanded = "brand-logo-module--expanded--215d7";
export var fadeInAnimation = "brand-logo-module--fadeInAnimation--7fa8f";
export var fadeInOnLoadGlobal = "brand-logo-module--fade-in-on-load--global--adf7a";
export var fullHeightGlobal = "brand-logo-module--full-height--global--df9f9";
export var fullHeightOmittingNavGlobal = "brand-logo-module--full-height-omitting-nav--global--b265e";
export var headingTextGlobal = "brand-logo-module--heading-text--global--18e23";
export var ingressTextGlobal = "brand-logo-module--ingress-text--global--be63a";
export var light = "brand-logo-module--light--dac56";
export var linkColorChangeTransitionGlobal = "brand-logo-module--link-color-change-transition--global--647df";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "brand-logo-module--page-heading-text--global--9291e";
export var paragraphTextGlobal = "brand-logo-module--paragraph-text--global--d6c49";
export var staticLogo = "brand-logo-module--staticLogo--5dfbb";
export var subheadingTextGlobal = "brand-logo-module--subheading-text--global--e7b47";
export var withAnimationDelay = "brand-logo-module--withAnimationDelay--f750f";
export var withHoverEffect = "brand-logo-module--withHoverEffect--4a6fe";